import styled from 'styled-components';

export const FieldsRow = styled.div`
  display: flex;
  margin-bottom: 20px;
  gap: 16px
`;

export const MainWrapper = styled.div`
  width: fit-content;
`;
